import React from 'react';


const Forbidden = (props) => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center">
            <h1>يبدو ان ليس لديك صلاحيات كافية يرجي المراجعة مع الادارة</h1>
        </div>
    )
}


export default Forbidden;